import { Standard } from '@getvim/vim-connect';

export const contactInfo: Standard.Entities.ContactInfo = {
  mobilePhoneNumber: '',
  faxNumber: '',
  email: '',
};
